import { computed } from 'vue';
import { isOppositeFlowRulePredicate, useFlowRuleName, useI18n } from '@/composables';
import { MoveDirectionEnum } from '@/services/models/Enums';
import type { RuleError } from '@/composables/useFlowNavigationErrors';

type FlowNavigationRuleItem = {
  default?: boolean;
  name?: string;
  status?: string;
  conditions?: Record<string, unknown>;
};

type FlowNavigationRuleProps = {
  item: FlowNavigationRuleItem;
  ruleIndex: number;
  length: number;
  ruleError?: RuleError;
};

const canMoveUp = (index: number) => index > 1;

const canMoveDownAlt = (index: number, length: number) => index < length - 1;

export const useFlowNavigationRule = (props: FlowNavigationRuleProps) => {
  const { t } = useI18n();
  const { buildFlowRuleName } = useFlowRuleName();

  const moveDirectionEnum = {
    up: MoveDirectionEnum.up,
    down: MoveDirectionEnum.down,
  };

  const name = computed(() =>
    buildFlowRuleName(
      { conditions: props.item.conditions || {}, name: props.item.name },
      false,
      false,
    ),
  );

  const translatedName = (ruleName: string) => {
    if (ruleName === 'Default') return t('Default');
    return ruleName;
  };

  return {
    t,
    name,
    moveDirectionEnum,
    canMoveUp,
    canMoveDownAlt,
    isOppositeFlowRulePredicate,
    translatedName,
  };
};
